import { render, staticRenderFns } from "./AuthCodeNotify.vue?vue&type=template&id=38e568ea&"
import script from "./AuthCodeNotify.vue?vue&type=script&lang=js&"
export * from "./AuthCodeNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports